import { COLORS } from "../../constants";
import { settings } from "../../settings/settings";
import { BuffUtils } from "../../utils/buff";
import { getQT } from "../../utils/dom";
export const updateTotalBuffMultiplier = () => {
    if (!settings.showTotalBuffMultiplier)
        return;
    const totalMultEl = getQT("totalMult");
    if (!totalMultEl)
        return;
    let total = 1;
    Object.keys(Game.buffs).forEach((key) => {
        const buff = Game.buffs[key];
        if (!buff)
            return;
        const buffMult = BuffUtils.getMultiplier(buff);
        if (buffMult)
            total *= buffMult;
    });
    const multColor = total > 1 ? COLORS.green : total < 1 ? COLORS.red : "inherit";
    totalMultEl.innerHTML = `
    <span>Total multiplier: <span style="color: ${multColor};">x${Beautify(total, 1)}</span></span>
  `;
};
